import React from 'react';
import PropTypes from 'prop-types';

import { getResourcePath } from '@spotahome/soyuz/client';

import HeroContainer from '../components/HeroContainer';
import Search from '../components/Search';
import { SeoCitiesConsumer } from '../context/SeoCitiesContext';
import './Hero.scss';

function getImages(image) {
  return {
    mobile: getResourcePath(
      `/images/hero/${image.replace('.jpg', '-mobile.jpg')}`
    ),
    desktop: getResourcePath(
      `/images/hero/${image.replace('.jpg', '-desktop.jpg')}`
    )
  };
}

const Hero = props => (
  <HeroContainer images={getImages(props.images[0])}>
    <div className="hero__container">
      <h1 className="hero__title">{props.title}</h1>
      <p className="hero__subtitle">{props.subtitle}</p>
      <SeoCitiesConsumer>
        {({ cities, currentCity }) => (
          <Search
            seeMoreLink={props.seeMoreLink}
            cities={cities}
            currentCity={currentCity}
          />
        )}
      </SeoCitiesConsumer>
    </div>
  </HeroContainer>
);

Hero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  seeMoreLink: PropTypes.string.isRequired
};

export default Hero;
